
import React, { PureComponent } from "react";
import PageHeaderWrapper from "../../components/PageHeaderWrapper/index";
import { Button, Card, notification, Row, Col, Form, Select, Tabs, Modal } from "antd";
import _ from "lodash";

import Request, { API_URL } from "../../request";
import { connect } from "react-redux";
import { HiInformationCircle } from "react-icons/hi";

const TabPane = Tabs.TabPane

const Option = Select.Option;


@Form.create()
class ProgramSettings extends React.Component {
    state = {
        activeTab: "0",
        allWhatsappTemplates: [],
        welcomeTemplate: null,
        studentRegisterTemplate: null,
        pointAddTemplate: null,
        pointDeductTemplate: null,
        modalData: null,
        modalOpen: false
    }

    loadWhatsappTemplates = async () => {
        let response = await Request.getTemplatesForCommunication('Whatsapp')
        let allWhatsappTemplates = []
        _.each(response, (template) => {
            allWhatsappTemplates.push({ id: template._id, display: template.templateName })
        })
        this.setState({ allWhatsappTemplates })
    }

    loadLoyalityProgramSettings = async () => {
        let response = await Request.getLoyalityProgramSettings()

        this.setState({ welcomeTemplate: response.welcomeTemplate, studentRegisterTemplate: response.studentRegisterTemplate, pointAddTemplate: response.pointAddTemplate, pointDeductTemplate: response.pointDeductTemplate })
        this.props.form.setFieldsValue(response)
    }

    async componentDidMount() {
        this.loadWhatsappTemplates()
        this.loadLoyalityProgramSettings()
    }

    callback = (value) => {
        this.setState({ activeTab: value })
    }

    handleOk = () => {
        this.setState({ modalOpen: false })
    };
    handleCancel = () => {
        this.setState({ modalOpen: false, modalData: null })
    };


    showData = async (templateId) => {
        let response = await Request.getTemplateById({ id: templateId })
        let { doc } = response
        this.setState({ modalData: doc, modalOpen: true })
    }

    handleFormSubmit = (e) => {
        let { form } = this.props
        e.preventDefault()
        form.validateFieldsAndScroll(async (err, valData) => {
            let values = {
                welcomeTemplate: this.state.welcomeTemplate,
                studentRegisterTemplate: this.state.studentRegisterTemplate,
                pointAddTemplate: this.state.pointAddTemplate,
                pointDeductTemplate: this.state.pointDeductTemplate
            }
            let response = await Request.addUpdateLoyalitySettings(values)
            if (response.success) {
                notification.success({
                    message: response.message
                })
            } else {
                notification.error({
                    message: response.message
                })
            }
        })
    }



    render() {
        let { form: { getFieldDecorator, setFieldsValue } } = this.props
        let { allWhatsappTemplates, modalOpen, modalData, welcomeTemplate, studentRegisterTemplate, pointAddTemplate, pointDeductTemplate } = this.state
        const inputTypes = {
            fields: [
                {
                    label: 'Welcome Template',
                    type: 'select',
                    key: 'welcomeTemplate',
                    required: true,
                    options: allWhatsappTemplates,
                    onChange: v => {
                        setFieldsValue({ welcomeTemplate: v })
                    }
                },
                {
                    label: 'Student Register Template',
                    type: 'select',
                    key: 'studentRegisterTemplate',
                    required: true,
                    options: allWhatsappTemplates,
                    onChange: v => {
                        setFieldsValue({ studentRegisterTemplate: v })
                    }
                },
                {
                    label: 'Add Loyality Point Template',
                    type: 'select',
                    key: 'pointAddTemplate',
                    required: true,
                    options: allWhatsappTemplates,
                    onChange: v => {
                        setFieldsValue({ pointAddTemplate: v })
                    }
                },
                {
                    label: 'Deduct Loyality Point Template',
                    type: 'select',
                    key: 'pointDeductTemplate',
                    required: true,
                    options: allWhatsappTemplates,
                    onChange: v => {
                        setFieldsValue({ pointDeductTemplate: v })
                    }
                },
            ]
        }
        return (
            <>
                <PageHeaderWrapper title={"Loyalty Program Settings"}>
                    <Card style={{ marginBottom: 10 }}>
                        <Tabs onChange={this.callback} type="card" activeKey={this.state.activeTab}>
                            <TabPane tab={"Whatsapp Templates"} key={0}>
                                {/* <Form onSubmit={this.handleSubmit} style={{ marginTop: 8 }}>
                        <Card>
                            <Row>
                                <Col span={24}>
                                <GetAllFormFields
                                    apiurl={API_URL}
                                    inputSchema={inputTypes}
                                    refresh={this.refreshFxn}
                                    loading={this.props.loading}
                                    getFieldDecorator={getFieldDecorator}
                                />
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    style={{ marginBottom: 10 }}
                                    loading={this.props.loading}>
                                    SAVE
                                </Button>
                                </Col>
                            </Row>
                            </Card>
                        </Form> */}
                                <Form onSubmit={this.handleFormSubmit}>
                                    <Row style={{ marginTop: 10, marginBottom: 10 }}>
                                        <Col span={4}><label htmlFor="welcomeTemplate" className="ant-form-item-required" title="Welcome Template">Welcome Template</label></Col>
                                        <Col span={16}>
                                            <Select value={this.state.welcomeTemplate}
                                                style={{ width: 389 }}
                                                showSearch={true}
                                                required={true}
                                                onChange={(v) => {
                                                    this.props.form.setFieldsValue({ welcomeTemplate: v })

                                                    this.setState({ welcomeTemplate: v })
                                                }}>
                                                {allWhatsappTemplates.map((item, key) => {
                                                    return (
                                                        <Option key={item.id} value={item.id}>{item.display}</Option>
                                                    )
                                                })}
                                            </Select>
                                            {
                                                welcomeTemplate && (
                                                    <HiInformationCircle onClick={() => this.showData(this.state.welcomeTemplate)} style={{ cursor: 'pointer', alignContent: 'right', fontSize: '20px', color: 'blue' }} />
                                                )
                                            }

                                            {/* <Popover style={{width:'10px'}}  content={this.state.welcomeTemplateData}><HiInformationCircle style={{cursor:'pointer', alignContent:'right', fontSize:'20px', color:'blue'}} /></Popover> */}
                                        </Col>
                                    </Row>
                                    <Row style={{ marginTop: 10, marginBottom: 10 }}>
                                        <Col span={4}><label htmlFor="studentRegisterTemplate" className="ant-form-item-required" title="Student Register Template">Student Register Template</label></Col>
                                        <Col span={16}>
                                            <Select value={this.state.studentRegisterTemplate}
                                                style={{ width: 389 }}
                                                showSearch={true}
                                                required={true}
                                                onChange={(v) => {
                                                    this.props.form.setFieldsValue({ studentRegisterTemplate: v })

                                                    this.setState({ studentRegisterTemplate: v })
                                                }}>
                                                {allWhatsappTemplates.map((item, key) => {
                                                    return (
                                                        <Option key={item.id} value={item.id}>{item.display}</Option>
                                                    )
                                                })}
                                            </Select>
                                            {
                                                studentRegisterTemplate && (
                                                    <HiInformationCircle onClick={() => this.showData(this.state.studentRegisterTemplate)} style={{ cursor: 'pointer', alignContent: 'right', fontSize: '20px', color: 'blue' }} />
                                                )
                                            }

                                            {/* <Popover style={{width:'10px'}}  content={this.state.studentRegisterTemplateData}><HiInformationCircle style={{cursor:'pointer', alignContent:'right', fontSize:'20px', color:'blue'}} /></Popover> */}
                                        </Col>
                                    </Row>
                                    <Row style={{ marginTop: 10, marginBottom: 10 }}>
                                        <Col span={4}><label htmlFor="pointAddTemplate" className="ant-form-item-required" title="Point Add Template">Point Add Template</label></Col>
                                        <Col span={16}>
                                            <Select value={this.state.pointAddTemplate}
                                                style={{ width: 389 }}
                                                showSearch={true}
                                                required={true}
                                                onChange={(v) => {
                                                    this.props.form.setFieldsValue({ pointAddTemplate: v })

                                                    this.setState({ pointAddTemplate: v })
                                                }}>
                                                {allWhatsappTemplates.map((item, key) => {
                                                    return (
                                                        <Option key={item.id} value={item.id}>{item.display}</Option>
                                                    )
                                                })}
                                            </Select>
                                            {
                                                pointAddTemplate && (
                                                    <HiInformationCircle onClick={() => this.showData(this.state.pointAddTemplate)} style={{ cursor: 'pointer', alignContent: 'right', fontSize: '20px', color: 'blue' }} />
                                                )
                                            }

                                            {/* <Popover style={{width:'10px'}}  content={this.state.pointAddTemplateData}><HiInformationCircle style={{cursor:'pointer', alignContent:'right', fontSize:'20px', color:'blue'}} /></Popover> */}
                                        </Col>
                                    </Row>
                                    <Row style={{ marginTop: 10, marginBottom: 10 }}>
                                        <Col span={4}><label htmlFor="pointDeductTemplate" className="ant-form-item-required" title="Point Deduct Template">Point Deduct Template</label></Col>
                                        <Col span={16}>
                                            <Select value={this.state.pointDeductTemplate}
                                                style={{ width: 389 }}
                                                showSearch={true}
                                                required={true}
                                                onChange={(v) => {
                                                    this.props.form.setFieldsValue({ pointDeductTemplate: v })

                                                    this.setState({ pointDeductTemplate: v })
                                                }}>
                                                {allWhatsappTemplates.map((item, key) => {
                                                    return (
                                                        <Option key={item.id} value={item.id}>{item.display}</Option>
                                                    )
                                                })}
                                            </Select>
                                            {
                                                pointDeductTemplate && (
                                                    <HiInformationCircle onClick={() => this.showData(this.state.pointDeductTemplate)} style={{ cursor: 'pointer', alignContent: 'right', fontSize: '20px', color: 'blue' }} />
                                                )
                                            }

                                            {/* <Popover style={{width:'10px'}}  content={this.state.pointDeductTemplateData}><HiInformationCircle style={{cursor:'pointer', alignContent:'right', fontSize:'20px', color:'blue'}} /></Popover> */}
                                        </Col>
                                    </Row>
                                    <Button
                                        type="primary"
                                        htmlType="submit"
                                        style={{ marginBottom: 10 }}
                                        loading={this.props.loading}>
                                        SAVE
                                    </Button>
                                </Form>
                            </TabPane>

                        </Tabs>
                    </Card>



                </PageHeaderWrapper>
                {
                    modalOpen ?
                        <Modal title={modalData && modalData.templateName} visible={modalOpen} onOk={this.handleOk} onCancel={this.handleCancel} footer={[]}>
                            <p dangerouslySetInnerHTML={{ __html: modalData.templateData }}></p>
                        </Modal>

                        : null
                }
            </>
        )
    }
}

const mapStateToProps = ({ global, router }) => ({
    loading: global.buttonLoading,
    categories: global.categories,
    search: router.location.search,
    pathname: router.location.pathname,
});
const mapDispatchToProps = (dispatch) => {
    return {
        dispatch,
    };
};
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ProgramSettings);